import React from 'react';
import { Button, Input, Select } from 'takeat-design-system-ui-kit';
import {
  FormContainer,
  FormRow,
  FormLabel,
  FormField,
  ButtonContainer,
  ErrorMessage,
} from './styles';

const HtmlToPrintForm = ({
  selectedPrintType,
  itemId,
  selectedMockName,
  printTypeOptions,
  mockNameOptions,
  isLoading,
  canFetchHtml,
  error,
  onPrintTypeChange,
  onIdChange,
  onMockNameChange,
  onFetchHtml,
  onReset,
}) => {
  const handlePrintTypeSelect = (option) => {
    onPrintTypeChange(option?.value || '');
  };

  const handleIdInputChange = (e) => {
    onIdChange(e.target.value);
  };

  const handleMockNameSelect = (option) => {
    onMockNameChange(option?.value || '');
  };

  const getSelectedOption = () => {
    return (
      printTypeOptions.find((option) => option.value === selectedPrintType) ||
      null
    );
  };

  const getSelectedMockOption = () => {
    return (
      mockNameOptions.find((option) => option.value === selectedMockName) ||
      null
    );
  };

  const getIdPlaceholder = () => {
    switch (selectedPrintType) {
      case 'table_session':
        return 'Digite o ID da comanda';
      case 'order_basket':
        return 'Digite o ID do pedido';
      case 'individual_bill':
        return 'Digite o ID da conta individual';
      default:
        return 'Digite o ID do item';
    }
  };

  return (
    <FormContainer>
      <FormRow>
        <FormField>
          <FormLabel>Mock de Teste (Desenvolvimento)</FormLabel>
          <Select
            options={mockNameOptions}
            value={getSelectedMockOption()}
            onChange={handleMockNameSelect}
            placeholder="Selecione um mock para teste"
            isDisabled={isLoading}
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <FormLabel>Tipo de Impressão</FormLabel>
          <Select
            options={printTypeOptions}
            value={getSelectedOption()}
            onChange={handlePrintTypeSelect}
            placeholder="Selecione o tipo de impressão"
            isDisabled={isLoading || selectedMockName}
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <FormLabel>ID do Item</FormLabel>
          <Input
            type="text"
            value={itemId}
            onChange={handleIdInputChange}
            placeholder={getIdPlaceholder()}
            disabled={isLoading || !selectedPrintType || selectedMockName}
          />
        </FormField>
      </FormRow>
      {error && (
        <FormRow>
          <ErrorMessage>{error}</ErrorMessage>
        </FormRow>
      )}
      <ButtonContainer>
        <Button variant="outlined" onClick={onReset} disabled={isLoading}>
          Limpar
        </Button>
        <Button
          onClick={onFetchHtml}
          disabled={!canFetchHtml}
          isLoading={isLoading}
        >
          {isLoading ? 'Carregando...' : 'Buscar HTML'}
        </Button>
      </ButtonContainer>
    </FormContainer>
  );
};

export default HtmlToPrintForm;
